















































































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { maxBy } from 'lodash'
import { ComponentVue } from '@/base'
import DataTableHeaderSortIcon from '@/components/molecules/DataTable/DataTableHeaderSortIcon.vue'
import { Col, ColInfo, Resize, Move, SortColumn, SCROLL_WIDTH } from '.'

@Component({
  components: { DataTableHeaderSortIcon }
})
export default class DataTableHeader extends ComponentVue {
  @Prop({
    type: Array
  })
  cols!: Col[]

  @Prop({
    type: Array
  })
  colsInfo!: ColInfo[]

  @Prop({
    type: Array
  })
  colsOrderList!: number[]

  @Prop({
    type: Object
  })
  resize!: Resize

  @Prop({
    type: Object
  })
  move!: Move

  @Prop({
    type: Number
  })
  bodyHeight!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isAllSelect!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAllSelect!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isDisplayCheckPrint!: boolean

  @Prop({
    type: Number,
    default: 0
  })
  headerHeight!: number

  defaultHeight: number = 32

  get maxColItem(): number {
    const maxItem = maxBy(this.cols, 'items')
    return maxItem === undefined ? 1 : maxItem.items.length
  }

  get height(): number {
    if (this.headerHeight === 0) {
      return this.defaultHeight * this.maxColItem
    }

    return this.headerHeight
  }

  get tableHeaderStyles() {
    return {
      height: this.height + 'px'
    }
  }

  get headerColumnStyles() {
    return (columnIndex: number) => {
      return {
        width:
          this.colsInfo[this.originalColumnIndex(columnIndex)].calcWidth + 'px'
      }
    }
  }

  get headerColumnResizeClass() {
    return (columnIndex: number) => {
      const classes = {
        resize:
          !this.isLastColumn(columnIndex) &&
          this.colsInfo[this.originalColumnIndex(columnIndex)].resizable,
        'display-none': this.move.doing
      }

      return classes
    }
  }

  get headerColumnResizeStyle() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (columnIndex: number) => {
      return {
        height: this.height + 'px'
      }
    }
  }

  get headerColItemClass() {
    return (columnIndex: number) => {
      const classes = {
        'cursor-pointer':
          this.colsInfo[this.originalColumnIndex(columnIndex)].moving &&
          !this.resize.doing,
        moving: this.move.doing && this.move.column.index === columnIndex
      }

      return classes
    }
  }

  get headerColumnMoveClass() {
    return (columnIndex: number) => {
      const classes = {
        moving: this.move.doing && this.move.ruler === columnIndex
      }

      return classes
    }
  }

  get headerColumnMoveStyle() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (columnIndex: number) => {
      return {
        height: this.bodyHeight + 'px'
      }
    }
  }

  get headerColumnScrollStyle() {
    return {
      width: SCROLL_WIDTH + 'px'
    }
  }

  @Emit('all-select')
  onAllSelectChange(): void {}

  onMouseMove(event: MouseEvent) {
    this.$emit('mouse:move', event)
  }

  onMouseDownResize(event: MouseEvent, columnIndex: number) {
    this.$emit('mouse:down:resize', event, columnIndex)
  }

  onMouseDownMove(event: MouseEvent, columnIndex: number): void {
    const el = event.target as HTMLElement
    if (!el.classList.contains('sort')) {
      this.$emit('mouse:down:move', event, columnIndex)
    }
  }

  originalColumnIndex(columnIndex: number): number {
    return this.colsOrderList[columnIndex]
  }

  isLastColumn(columnIndex: number): boolean {
    return columnIndex === this.colsInfo.length - 1
  }

  onClickSort(originalIndex: number, itemIndex: number, order: string): void {
    this.$emit('sort', {
      name: this.cols[originalIndex].items[itemIndex].name,
      order
    } as SortColumn)
  }
}
